export const addEventOnResize=(fn)=>{
    var originFn = window.onresize
    window.onresize =function () {
        originFn && originFn()
        fn()
    }
}